import { render, staticRenderFns } from "./Dashboard2.vue?vue&type=template&id=db87d18a&scoped=true&"
import script from "./Dashboard2.vue?vue&type=script&lang=js&"
export * from "./Dashboard2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db87d18a",
  null
  
)

export default component.exports